/*
* @Description: file content
* @Version: file content
* @Author: hujunke
* @Date: 2023-11-06 15:10
* @LastEditors:
* @LastEditTime: 2023-11-06 15:10
*/
// 随访中心菜单
import LayoutSidebar from '@/layout/layout-sidebar/layout-sidebar';
import {
  zidian,
  tongji,
  sfyonghu
} from '@/utils/images'
// 动态路由，基于用户权限动态去加载
const dynamicRoutes = [
  {
    path: '/',
    component: LayoutSidebar,
    name: '用户管理',
    menuShow: false,
    idthat: '800',
    leaf: false, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: sfyonghu,
    meta: {
      idthat: '800',
    },
    children: [
      {
        name: '角色管理',
        path: '/followUp/admin/userManage/roleManage',
        component: () => import('@/views/followUp/admin/userManage/roleManage/roleList'),
        menuShow: true,
        meta: {
          idthat: '800',
        },
      },
      {
        name: '角色详情',
        path: '/followUp/admin/userManage/roleManage/:id',
        component: () => import('@/views/followUp/admin/userManage/roleManage/roleDetail'),
        menuShow: false,
        meta: {
          idthat: '800',
        },
      },
      {
        name: '账号管理',
        path: '/followUp/admin/userManage/accountManage',
        component: () => import('@/views/followUp/admin/userManage/accountManage/accountList'),
        menuShow: false,
        meta: {
          idthat: '800',
        },
      },
      {
        name: '员工管理',
        path: '/followUp/admin/userManage/staff',
        component: () => import('@/views/followUp/admin/userManage/staffManage/staffList'),
        menuShow: false,
        idthat: '800',
        meta: {
          idthat: '800',
        },
      }
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: true,
    menuShow: false,
    children: [
      {
        path: '/followUp/admin/userManage/roleDetail',
        component: () => import('@/views/followUp/admin/userManage/roleManage/roleDetail'), name: '角色详情',
        meta: {
          idthat: '800',
          activeMenu: "/followUp/admin/userManage/roleManage",
        },
      },
    ]
  },
  {
    name: '字典管理',
    path: '/',
    component: LayoutSidebar,
    idthat: '820',
    menuShow: false,
    leaf: false, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: zidian,
    meta: {
      idthat: '820',
    },
    children: [
      {
        name: '院区配置',
        path: '/followUp/admin/dictManage/hospManage',
        component: () => import('@/views/followUp/admin/dictManage/hospManage/wardList'),
        menuShow: true,
        meta: {
          idthat: '820',
        },
      },
      {
        name: '科室配置',
        path: '/followUp/admin/dictManage/deptManage',
        component: () => import('@/views/followUp/admin/dictManage/deptManage/deptList'),
        menuShow: true,
        meta: {
          idthat: '820',
        },
      },
      {
        name: '疾病维护',
        path: '/followUp/admin/dictManage/diseaseManage',
        component: () => import('@/views/followUp/admin/dictManage/diseaseManage/diseaseList'),
        menuShow: true,
        meta: {
          idthat: '820',
        },
      },
      {
        name: "潜在疾病维护",
        path: "/followup/admin/dictManage/therapeuticRegimen",
        component: () => import('@/views/followUp/admin/dictManage/therapeuticRegimen/list'),
        menuShow: true,
        meta: {
          idthat: '820',
        }
      },
      {
        name: '提醒类型维护',
        path: '/followUp/admin/dictManage/reminderType',
        component: () => import('@/views/followUp/admin/dictManage/reminderType'),
        menuShow: true,
        meta: {
          idthat: '820',
        },
      },
      {
        name: '回访类型维护',
        path: '/followUp/admin/dictManage/returnType',
        menuShow: true,
        component: () => import("@/views/followUp/admin/dictManage/returnType"),
        meta: {
          idthat: '820',
        }
      }
    ],
  },
  {
    name: '运营管理',
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    leaf: false,
    // iconCls: 'menu-icon',
    // iconUrl: 
    meta: {
      idthat: '820'
    },
    children: [
      {
        name: '医生推荐配置',
        path: '/followUp/admin/operationManage/doctorRecommend',
        menuShow: true,
        component: () => import('@/views/followUp/admin/operationManage/recommendDoctorConfig'),
        meta: {
          idthat: '820'
        }
      }
    ]
  }
];
export default dynamicRoutes;


